import { useState, useEffect } from 'react';

import { Modal, Checkbox, message } from 'antd';

import styles from '@/styles/customScroll.module.css';

export default function SellAbroadModel({ isShowMateriel, setIsShowMateriel, handleChangeCheck }) {
  const [isViewChecked, setIsViewChecked] = useState(false);

  useEffect(() => {
    setIsViewChecked(false);
  }, [isShowMateriel]);

  const onChange = (e) => {
    setIsViewChecked(e.target.checked);
  };

  const handleOk = () => {
    if (!isViewChecked) {
      message.warning('请先阅读购买须知并勾选此项！');
      return;
    }
    handleChangeCheck();
    setIsShowMateriel(false);
  };

  return (
    <Modal
      title={<span className="text-[16px] font-bold">客户购买前须知</span>}
      open={isShowMateriel}
      width={550}
      maskClosable={false}
      footer={null}
      centered
      bodyStyle={{ padding: '0 25px 20px 25px' }}
      wrapClassName="sellAbroad-explain"
      onCancel={() => setIsShowMateriel(false)}
    >
      <div className={`h-[500px] overflow-y-auto ${styles['custom-scroll']} pr-[10px]`}>
        <p className="mb-[15px] text-[red]">
          1.
          因关税政策变化，您购买的商品下单后根据货物的产地不同需要支付关税（以货物报关实时关税为准）,您应在收到立创商城工作人员通知后2个工作日内支付完毕，若逾期支付,立创商城有权取消您的订单，已支付货款作为违约金不予退还，若违约金无法弥补立创商城损失的，立创商城有权要求您继续补足。
        </p>
        <p className="mb-[15px]">
          2.
          海外代购商品存在出口审核、限购、无法报关等不确定因素，若因限购或报关等不可抗因素导致交期延期或订单取消等情况，商城客服将第一时间通知客户，联系客户处理，商城不承担由此而导致的任何直接和间接损失。
        </p>
        <p className="mb-[15px]">
          3.
          海外代购数据来源于供应商，基本保证实时更新，但不排除因网络或供应商网站本身数据问题导致产品库存或价格产生变化，请在下单后尽快支付。
        </p>
        <p className="mb-[15px]">
          4.
          立创商城海外代购服务免国际邮费，如果部分型号因采购数量过多、体积较大或重量较重等原因出现超重时，视供应商不同可能需要补交超出部分的运费。
        </p>
        <p className="mb-[15px]">
          5.
          部分商品（如继电器、带通滤波器、衰减器、各类模块、线缆等）可能需要增收3%-30%的关税；开关、保险丝、气体放电管、连接器、电池等需要商检和3C认证费用。商检费用为100元/型号；3C认证费用会根据报关型号平摊，若只有单个型号费用为100元。如有疑问，可联系客服人员进行解答。
        </p>
        <p className="mb-[15px]">
          6. 代购渠道中Texas Instruments不承诺批次和包装，除Texas
          Instruments外的其他海外代购物料基本默认批次为5年内，如有特殊要求，请先咨询客服。
        </p>
        <p className="mb-[15px]">
          7. 受供应商库存影响，个别代购物料可能会出现发货供应商变动的情况，如介意请在订单备注中说明。
        </p>
        <p className="mb-[15px]">8. 海外代购订单下单完成支付后，不支持取消订单退款退货，请知悉。</p>
        <p className="mb-[15px]">
          9.
          海外代购物料不影响功能使用的部分瑕疵问题的售后政策以海外供应商为准。如有售后问题，您必须提供随货供应商原标签才能受理。
        </p>
        <p className="mb-[15px]">
          【注意】请您收到货物后妥善保管好货物原标签，货物标签是协调售后的关键凭据，如有遗失、将无法受理。
        </p>
      </div>
      <div className="mt-[24px]">
        <Checkbox checked={isViewChecked} onChange={onChange}>
          <span className="text-[#000000] hover:text-[#0093E6]">我已阅读并知悉上述事项</span>
        </Checkbox>
      </div>
      <div className="mt-[24px] flex items-center justify-end">
        <button
          className="h-[32px] w-[65px] rounded-[6px] border-[1px] border-solid border-[rgba(0,0,0,0.15)] bg-white hover:opacity-[0.8]"
          onClick={() => setIsShowMateriel(false)}
        >
          取消
        </button>
        <button
          className="ml-[10px] h-[32px] w-[65px] rounded-[6px] bg-[#0093E6] text-center leading-[32px] text-[white] hover:opacity-[0.8]"
          onClick={handleOk}
        >
          确定
        </button>
      </div>
    </Modal>
  );
}
